import { mobileApiRequest } from '../../apiRequests'

export const getAvailableRecipes = async () => {
    const action = {
        action: 'getRecipeMappings',
        isDev: process.env.REACT_APP_SCOOP_ENV === 'dev',
    }

    return await mobileApiRequest(action)
}
